export function createSimpleReducer<S>(defaultState: S) {
  return (state: S = defaultState) => state;
}

export function booleanReducer(state?: boolean) {
  return !!state;
}
